import { Injectable } from '@angular/core';
export type tipoAlert = "warning" | "success" | "danger";
export type posizioneAlert = "sticky" | "static";

@Injectable({
  providedIn: 'root'
})
export class AlertService {
  get show(): boolean {
    return this._show;
  }

  set show(value: boolean) {
    this._show = value;
  }

  get tipo(): tipoAlert {
    return this._tipo;
  }

  set tipo(value: tipoAlert) {
    this._tipo = value;
  }

  get messaggio(): string {
    return this._messaggio;
  }

  set messaggio(value: string) {
    this._messaggio = value;
  }

  get ttl(): number | undefined {
    return this._ttl;
  }

  set ttl(value: number | undefined) {
    this._ttl = value;
  }

  get posizione():  posizioneAlert{
    return this._posizione;
  }

  set posizione(value: posizioneAlert) {
    this._posizione = value;
  }

  private _show: boolean;
  private _tipo: tipoAlert;
  private _messaggio: string;
  private _ttl?: number;
  private _posizione: posizioneAlert;

  constructor() {
    this._show = false;
    this._tipo = "danger";
    this._messaggio = "Messaggio";
    this._posizione = "static";
  }

  creaAlert(messaggio: string, tipo: tipoAlert, posizione: posizioneAlert, tempo?: number, mostra?: boolean): void{
    this.messaggio = messaggio;
    this.tipo = tipo;
    this.ttl = tempo;
    this.posizione = posizione;
    if(mostra){
      this.mostraAlert();
    }
  }

  mostraAlert(): void{
    this.show = true;
    if(this.ttl){
      setTimeout(() => {
        this.show = false;
      }, this.ttl)
    }
  }

  close(): void{
    this.show = false;
  }
}
